import { TasksTable } from "@/components/TasksTable";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/contexts/AuthContext";
import { useTaskStats } from "@/features/tasks/hooks/useTasks";
import { createFileRoute } from "@tanstack/react-router";
import { debounce, parseAsString, useQueryState } from "nuqs";

export const Route = createFileRoute("/dashboard/admin/tasks/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userProfile } = useAuth();
  const { totalTasks, overdueTasks, loading } = useTaskStats(userProfile?.uid);
  const [search, setSearch] = useQueryState("search", parseAsString.withDefault(""));

  const handleSearchChange = (value: string) => {
    setSearch(value, {
      limitUrlUpdates: value === "" ? undefined : debounce(300)
    });
  };

  return (
    <div className="flex h-full flex-1 flex-col space-y-8 p-8">
      <div className="flex items-center justify-between space-y-2">
        <div>
          <div className="flex items-center gap-3">
            <h2 className="text-2xl font-bold tracking-tight">Tasks</h2>
            {!loading && totalTasks > 0 && (
              <Badge variant={overdueTasks > 0 ? "destructive" : "secondary"}>
                {totalTasks} {totalTasks === 1 ? "task" : "tasks"}
              </Badge>
            )}
          </div>
          <p className="text-muted-foreground">Manage all tasks across projects</p>
        </div>
      </div>
      <TasksTable searchValue={search} onSearchChange={handleSearchChange} />
    </div>
  );
}
